import { render, staticRenderFns } from "./setCost.vue?vue&type=template&id=c671e20a&scoped=true&"
import script from "./setCost.vue?vue&type=script&lang=js&"
export * from "./setCost.vue?vue&type=script&lang=js&"
import style0 from "./setCost.vue?vue&type=style&index=0&id=c671e20a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c671e20a",
  null
  
)

export default component.exports